import {useEffect} from 'react';
import {observer} from 'mobx-react-lite';

import {settingsStore} from '@/shared/stores/settingsStore';
import {leerplatformSettingsStore} from '@/shared/stores/leerplatformSettingsStore';
import {userStore} from '@/shared/stores/userStore';
import {updateUserDetails, updateUserDetailsCentral} from './updateUserDetails';

// Deze twee calls hingen aan de timer van DelayedAnnounceKit: twee seconden na
// het inloggen, ongeacht of de settings er al waren. Waren ze er niet, dan gooide
// elke call en gebeurde er verder niets - geen tweede poging. Op 10 september
// verloor 18 tot 34 promille van de sessies die race, tegen 2 tot 13 in de week
// ervoor.
//
// Nu wachten ze op wat ze nodig hebben. De poort bevat alles waar de functies op
// kunnen struikelen, inclusief het access token: dat komt uit een andere store,
// gevuld door de OIDC-saga, en is dus niet gegarandeerd aanwezig zodra de
// settings er zijn.
export const UserDetailsSync = observer(({userId}: {userId?: string}) => {
    const signedIn = Boolean(userId && userStore.accessToken);
    const portalReady = Boolean(signedIn && settingsStore.portalApiUrl);
    const centralReady = Boolean(
        signedIn &&
            settingsStore.portalIdentifier &&
            leerplatformSettingsStore.getAcademyDepartmentsUrl,
    );

    useEffect(() => {
        if (!portalReady) return;
        updateUserDetails().catch((error) =>
            console.error('Bijwerken van de gebruikersgegevens mislukt.', error),
        );
    }, [portalReady]);

    useEffect(() => {
        if (!centralReady) return;
        updateUserDetailsCentral().catch((error) =>
            console.error('Melden van de logon mislukt.', error),
        );
    }, [centralReady]);

    return null;
});
